import SteddyStar from "@/components/SteddyStar";

const Footer = () => (
  <footer className="border-t border-border bg-background py-12">
    <div className="container mx-auto flex flex-col items-center justify-between gap-4 px-6 md:flex-row">
      <div className="flex items-center gap-1.5">
        <span className="text-lg font-bold text-foreground">Steddy</span>
        <SteddyStar className="-mt-1 h-4 w-4 text-primary" />
      </div>
      <p className="text-xs text-muted-foreground">
        © {new Date().getFullYear()} Steddy.AI. The autonomous back-office for MCA funders.
      </p>
      <div className="flex items-center gap-6">
        <a
          href="/privacy-policy"
          className="steddy-transition text-xs text-muted-foreground hover:text-foreground"
        >
          Privacy Policy
        </a>
        <a
          href="#"
          className="steddy-transition text-xs text-muted-foreground hover:text-foreground"
        >
          Terms of Service
        </a>
        <a
          href="#"
          className="steddy-transition text-xs text-muted-foreground hover:text-foreground"
        >
          Contact
        </a>
      </div>
    </div>
  </footer>
);

export default Footer;
